/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

//timeout in seconds
// let seconds_timeout = 3600;

// cognito aut
import { Auth } from "@aws-amplify/auth";
import { CognitoUserSession } from "amazon-cognito-identity-js";

export default {
  setIDToken(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setIDToken", payload);
  },
  setAccessToken(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setAccessToken", payload);
  },
  setUsername(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setUsername", payload);
  },
  setIsAuthenticated(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setIsAuthenticated", payload);
  },
  setEmail(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setEmail", payload);
  },
  setSession(
    context: { commit: (arg0: string, arg1: CognitoUserSession) => void },
    payload: CognitoUserSession
  ): void {
    context.commit("setSession", payload);
  },
  setGivenName(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setGivenName", payload);
  },
  setFamilyName(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setFamilyName", payload);
  },
  setStationCode(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setStationCode", payload);
  },
  setLoginNumber(
    context: { commit: (arg0: string, arg1: number) => void },
    payload: number
  ): void {
    context.commit("setLoginNumber", payload);
  },
  setCompanyName(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setCompanyName", payload);
  },
  setTitle(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setTitle", payload);
  },
  setDepartment(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setDepartment", payload);
  },
  setShowPage(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setShowPage", payload);
  },
  setMainMenuCode(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setMainMenuCode", payload);
  },
  setFlg(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setFlg", payload);
  },
  setThreeDigitCode(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setThreeDigitCode", payload);
  },
  setParentCode(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setParentCode", payload);
  },
  setCountry(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setCountry", payload);
  },
  setStatus(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setStatus", payload);
  },
  setArea(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setArea", payload);
  },
  setId(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setId", payload);
  },
  setDataId(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setDataId", payload);
  },
  setFtpUserId(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setFtpUserId", payload);
  },
  setuserId(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setuserId", payload);
  },
  setUserdata(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setUserdata", payload);
  },
  setSubMenuList(
    context: { commit: (arg0: string, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setSubMenuList", payload);
  },
  setSubMenuItem(
    context: { commit: (arg0: string, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setSubMenuItem", payload);
  },
  setIsNewsFlg(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setIsNewsFlg", payload);
  },
  setShowPageTitle(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setShowPageTitle", payload);
  },
  setPageClickCount(
    context: {commit: (arg0: string,arg1: number) => void},
    payload: number
  ): void {
    context.commit("setPageClickCount", payload);
  },
  setShowedMenuList(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setShowedMenuList", payload);
  },
  setNewsData(
    context: { commit: (arg0: any, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setNewsData", payload);
  },
  setChangePage(
    context: { commit: (arg0: any, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setChangePage", payload);
  },
  setgroupUserId(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setgroupUserId", payload);
  },
  setgroupLName(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setgroupLName", payload);
  },
  setgroupFName(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setgroupFName", payload);
  },
  setgroupEmail(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setgroupEmail", payload);
  },
  setgroup(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setgroup", payload);
  },

  setStationListData(
    context: { commit: (arg0: any, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setStationListData", payload);
  },
  setSelectedStation(
    context: { commit: (arg0: any, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setSelectedStation", payload);
  },
  setApprovalNotice(
    context: { commit: (arg0: any, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setApprovalNotice", payload);
  },
  setSubExistMenu(
    context: { commit: (arg0: any, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setSubExistMenu", payload);
  },
  setSearchedUserList(
    context: { commit: (arg0: any, arg1: any) => void },
    payload: any
  ): void {
    context.commit("setSearchedUserList", payload);
  },
  setIsPageLoad(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setIsPageLoad", payload);
  },
  setPcCompanyListData(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setPcCompanyListData", payload);
  },
  setCompanyAdminListData(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setCompanyAdminListData", payload);
  },
  setEditSationData(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setEditSationData", payload);
  },
  setFileFormatList(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: any
  ): void {
    context.commit("setFileFormatList", payload);
  },
  setIsAltLoginAdmin(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: any
  ): void {
    context.commit("setIsAltLoginAdmin", payload);
  },
  setParamKDPSalesNoteList(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: any
  ): void {
    context.commit("setParamKDPSalesNoteList", payload);
  },
  setKDPSalesNoteSearchData(
    context: { commit: (arg0: any, arg1: boolean) => void },
    payload: any
  ): void {
    context.commit("setKDPSalesNoteSearchData", payload);
  },
  setKDPSalesNoteScreen(
    context: { commit: (arg0: string, arg1: boolean) => void },
    payload: boolean
  ): void {
    context.commit("setKDPSalesNoteScreen", payload);
  },
  async logout(context: { commit: (arg0: string) => void }): Promise<void> {
    console.log("log out called");
    await Auth.signOut();
    context.commit("logout");
  },
  async signIn(context: { commit: (arg0: string) => void }): Promise<void> {
    console.log("sign in called");
    if (typeof process.env.VUE_APP_AWS_COGNITO_IDP !== "undefined") {
      try{
        console.log("federatedSignIn Start");
        await Auth.federatedSignIn({
          customProvider: process.env.VUE_APP_AWS_COGNITO_IDP,
        });
        console.log("federatedSignIn Successfully End");
      } catch (error) {
        console.error('Error during federated sign-in:', error);
      }
    }

    console.log("federatedSignIn End");
    context.commit("signedIn");
  },
  async currentUserInfo(context: {
    commit: (arg0: string, arg1: string) => void;
  }): Promise<void> {
    console.log("currentUserInfo in called");
    const currentUser = await Auth.currentUserInfo();
    context.commit("setUsername", currentUser);
  },
  autoLogout(context: {
    dispatch: (arg0: string) => void;
    commit: (arg0: string) => void;
  }): void {
    context.dispatch("logout");
    context.commit("setAutoLogout");
  },
};
